import {StatusEventSignalEventsDetails} from '@models/machine/status-event-signal/status-event-signal-events-details';

export class StatusEventPage {

  id: number = -1;
  name: string = '';
  machineId: number = -1;
  menuItemId: string = '';
  statusEventsDetails: Map<number, StatusEventSignalEventsDetails> = new Map<number, StatusEventSignalEventsDetails>();
  signals: number[] = [];

  constructor(id: number, name: string) {
    this.id = id;
    this.name = name;
  }
}
